import createAxiosInstance from '../utils/axiosInstance';
import Env from '../env/Env';

export interface GraphVersion {
  id: number;
  dashboardGraphId: number;
  version: number;
  name: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface GraphWithVersions {
  id: number;
  dashboardViewId: number;
  chartId: string;
  title: string;
  chartType: string;
  order: number;
  boxWidth: string;
  isEnabled: number;
  selectedVersion?: number;
  versions?: GraphVersion[];
}

const request = createAxiosInstance(`${Env.API_BASE}/api/dashboard-views`);

export const graphVersionsAPIsService = {
  getGraphVersions: (graphId: number): Promise<GraphVersion[]> => {
    return new Promise((resolve, reject) => {
      request
        .get(`/graph-versions/${graphId}`)
        .then(({ data }) => {
          resolve(data.data || []);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || err?.response?.data?.message || 'Failed to fetch graph versions');
        });
    });
  },

  createGraphVersion: (versionData: { dashboardGraphId: number; version: number; name: string; description?: string }): Promise<GraphVersion> => {
    return new Promise((resolve, reject) => {
      request
        .post('/graph-versions', versionData)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || err?.response?.data?.message || 'Failed to create graph version');
        });
    });
  },

  updateGraphVersion: (id: number, versionData: { name?: string; description?: string }): Promise<GraphVersion> => {
    return new Promise((resolve, reject) => {
      request
        .put(`/graph-versions/${id}`, versionData)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || err?.response?.data?.message || 'Failed to update graph version');
        });
    });
  },

  deleteGraphVersion: (id: number): Promise<void> => {
    return new Promise((resolve, reject) => {
      request
        .delete(`/graph-versions/${id}`)
        .then(() => {
          resolve();
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || err?.response?.data?.message || 'Failed to delete graph version');
        });
    });
  },

  selectGraphVersion: (graphId: number, version: number): Promise<any> => {
    return new Promise((resolve, reject) => {
      request
        .put(`/graph-versions/graph/${graphId}/select-version`, { version })
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || err?.response?.data?.message || 'Failed to select graph version');
        });
    });
  },
};

